<template>
  <div>
    <BaseEchart :option="option" :height="height" :width="width"></BaseEchart>
  </div>
</template>

<script>
import BaseEchart from "@/components/base-echart/base-echart.vue";

export default {
  components: {
    BaseEchart,
  },
  data() {
    return {
      dataList: [],
    };
  },
  mounted() {
    // 上面改成从x和y获取，然后循环生成，x为dataList的数量，y为dataList有几层children
    // 生成的数据结构如下：
    // this.dataList = this.generateData(this.x, this.y);
  },
  watch: {
    distData: {
      handler() {
        this.dataList = this.generateData(this.x, this.y);
      },
      deep: true,
      immediate: true,
    },
  },
  props: {
    distData: {
      type: Array,
      default: () => ({}),
    },
    width: {
      type: String,
      default: "150px",
    },
    height: {
      type: String,
      default: "240px",
    },
  },
  methods: {
    // 改成从dist获取
    generateData() {
      let dataList = [];
      for (let item of this.distData) {
        let data = {
          name: "",
          value: 10,
          selectable: false,
          itemStyle: {
            color: item.value == 0 ? "#fff" : item.color || "#fff",
            borderColor: item.color,
          },
          children: [],
        };
        this.generateChildren(data, item.max, { ...item });
        // console.log("data, item.max", data, item.max - 1, item);
        dataList.push(data);
      }
      return dataList;
    },

    // 生成children
    generateChildren(data, y, item) {
      const currentIndex = item.max - y + 2;
      if (y > 1) {
        data.children = [
          {
            name: y == 4 ? String(item.value) : "",
            value: 10,
            children: [],
            selectable: false,
            // 颜色
            itemStyle: {
              color: item.value >= currentIndex ? item.color : "#fff",
              // borderColor: item.borderColor,
              borderColor: item.color,
            },
            label: {
              rotate: "tangential",
              color: "#666",
            },
          },
        ];
        this.generateChildren(data.children[0], y - 1, item);
      }
      else if (y > 0) {
        // console.log("data.children", data.children)
        data.children = [
          {
            name: String(item.name),
            value: 10,
            // children: [],
            // selectable: false,
            // 颜色
            // itemStyle: {
            //   color: item.value >= currentIndex ? item.color : "#fff",
            //   borderColor: item.borderColor,
            //   borderWidth: 0,
            // },
            r0: "65%",
            r: "65%",
            label: {
              position: "outside",
              padding: 0,
              silent: false,
              color: item.color || "#fff",
              // 设置不同颜色
              fontSize: 12,
              rotate: 0,
              // rotate: "tangential",
            },
          },
        ];
        this.generateChildren(data.children[0], y - 1, item);
      }
    },
  },
  computed: {
    option() {
      return {
        series: {
          type: "sunburst",
          data: this.dataList,
          radius: [0, "75%"],
          selectedMode: false,
          select: false,
          selected: false,
          rootClick: false,
        },
      };
    },
  },
};
</script>
